<template>
  <div id="app" @keydown="appKeyDown">
    <header>
      <div id="headerControls" class="level">
        <div class="level-left">
          <button class="button" @click="toggleTranslit" title="Вкл./Выкл. транслит [Esc]">
            <font-icon v-if="translitEnable==true" icon="toggle-on" />
            <font-icon v-else icon="toggle-off" />
          </button>
          <button class="button" @click="spellcheck" title="Проверить орфографию [F7]">
            <font-icon icon="language" />
          </button>
          <button class="button" @click="copyIntoClipboard" title="Скопировать в буфер обмена [Ctrl+C]">
            <font-icon icon="clipboard" />
          </button>
        </div>
        <div class="level-item">
        </div>
        <div class="level-right">
          <div class="select">
            <select id="languages" v-model="selected" @change="loadDictionary" title="Выбрать язык" :disabled="!translitEnable">
              <option v-for="language in languages" :key="language.lang" :value="language">{{language.desc}}</option>
            </select>
          </div>
        </div>
      </div>
      <ul id="keymap">
        <li v-for="item in keymap" :key="item.key">
          <keymapItem :from="item.key" :to="item.value" :enabled="translitEnable" @charClicked="keymapKlicked"></keymapItem>
        </li>
      </ul>
    </header>
    <textarea ref="textarea" id="input" autofocus @keydown="translit" spellcheck="true" lang="ru_RU"></textarea>
    <spellChecker ref="spellChecker" @saved="spellcheckSaved" @closed="spellcheckClosed" />
  </div>
</template>

<script>
import keymapItem from "./components/keymapItem.vue";
import spellChecker from "./components/spellChecker.vue";

export default {
  name: "App",
  props: {
    isApp: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      languages: [
        {
          lang: "ru_RU",
          desc: "Русский",
          spell: "ru",
          selected: true
        },
        {
          lang: "ua_UA",
          desc: "Українська",
          spell: "uk"
        },
        {
          lang: "be_BY",
          desc: "Беларуская",
          spell: "be"
        }
      ],
      selected: {},
      translitmap: [],
      keymap: [],
      dictionary: "",
      translitEnable: true,
      baseurl: ""
    };
  },
  created() {
    if (localStorage.getItem("language")) {
      this.selected = JSON.parse(localStorage.getItem("language"));
    } else {
      this.selected = this.languages[0];
    }
    if (this.isApp) {
      this.baseurl = "/app/translit/";
    }
    this.loadDictionary();
  },
  methods: {
    translit(e) {
      if (e.ctrlKey || e.altKey || !this.translitEnable) {
        if (e.ctrlKey && e.code == "KeyC") {
          this.copyIntoClipboard();
        }
        return;
      }

      let textarea = e.srcElement;
      let cursor = textarea.selectionStart;
      let pre_char = textarea.value.substr(cursor - 1, 1);
      let cur_char = e.key;
      let new_char = cur_char;
      let offset = 0;

      if (pre_char != "") {
        this.translitmap.forEach(element => {
          if (element.key == pre_char + cur_char) {
            new_char = element.value;
            offset = 1;
            return;
          }
        });
      }
      if (new_char == cur_char) {
        this.translitmap.forEach(element => {
          if (element.key == cur_char) {
            new_char = element.value;
            return;
          }
        });
      }
      if (new_char != cur_char) {
        this.replaceChar(textarea, new_char, offset);
        e.preventDefault();
      }
    },
    keymapKlicked(new_char) {
      let textarea = document.getElementById("input");
      this.replaceChar(textarea, new_char, 0);
    },
    replaceChar(textarea, new_char, offset) {
      let cursorStart = textarea.selectionStart;
      let cursorEnd = textarea.selectionEnd;
      let first = textarea.value.substring(0, cursorStart - offset);
      let end = textarea.value.substring(cursorEnd, textarea.value.length);
      textarea.value = first + new_char + end;
      textarea.selectionEnd = cursorStart + 1;

      textarea.focus();
    },
    loadDictionary() {
      let url = this.baseurl + "static/" + this.selected.lang;
      console.log(url);
      this.$http.get(url).then(function(response) {
        this.dictionary = response.data;
        this.translitmap = this.loadGroup("Translit");
        this.keymap = this.loadGroup("Keymap");

        localStorage.setItem("language", JSON.stringify(this.selected));
      });
    },
    loadGroup(group) {
      let returnValue = [];
      let lines = this.dictionary.split("\n");
      let isGroup = false;

      for (let i = 0; i < lines.length; i++) {
        let line = lines[i];
        if (!isGroup && line == "[" + group + "]") {
          isGroup = true;
          continue;
        }
        if (isGroup && line[0] != "[") {
          if (line.indexOf("=") == -1) {
            continue;
          }
          let pair = line.split("=");
          returnValue.push({ key: pair[0], value: pair[1] });
        } else if (isGroup) {
          break;
        }
      }
      return returnValue;
    },
    appKeyDown(e) {
      let spellChecker = this.$refs.spellChecker;
      if (e.code == "Escape") {
        if (spellChecker.isActive) {
          spellChecker.close();
        } else {
          this.toggleTranslit();
        }
      } else if (!spellChecker.isActive && e.code == "F7") {
        this.spellcheck();
      } else if (spellChecker.isActive && e.ctrlKey && e.code == "Enter") {
        spellChecker.save();
      }
    },
    toggleTranslit() {
      this.translitEnable = !this.translitEnable;
      this.focus();
    },
    copyIntoClipboard() {
      let textarea = document.getElementById("input");
      let cursorStart = textarea.selectionStart;
      let cursorEnd = textarea.selectionEnd;
      if (cursorStart == cursorEnd) {
        textarea.select();
      }
      document.execCommand("copy");
      textarea.selectionStart = cursorStart;
      textarea.selectionEnd = cursorEnd;
    },
    spellcheck() {
      let text = document.getElementById("input").value;
      if (text.trim().length > 0) {
        let spellChecker = this.$refs.spellChecker;
        spellChecker.show(text, this.selected);
      } else {
        this.focus();
      }
    },
    spellcheckSaved(new_text) {
      this.$refs.textarea.value = new_text;
    },
    spellcheckClosed() {
      this.focus();
    },
    focus() {
      this.$refs.textarea.focus();
    }
  },
  components: {
    keymapItem,
    spellChecker
  }
};
</script>

<style>
html,
body,
#app {
  height: 100%;
  overflow-y: auto !important;
}

#app {
  display: flex;
  flex-direction: column;
}

header,
.modal-card-head,
.modal-card-foot {
  background-color: #eff0f1;
}

#headerControls {
  margin: 0.5rem;
  text-align: center;
}

#headerControls .button {
  min-width: 48px;
  justify-content: center;
}

#keymap {
  padding: 0px;
  margin: 0 0.5rem 0.5rem;
  text-align: center;
}

#keymap li {
  display: inline-block;
}

#input {
  padding: 0.5rem;
  width: 100%;
  flex: 1;
  min-height: 260px;
  resize: none;
}

.level-left .button {
  margin-right: 0.5rem;
}

.level-left .button:last-child {
  margin-right: 0;
}

.level-right .button {
  margin-left: 0.5rem;
}

.level-right .button:first-child {
  margin-left: 0;
}

@media (min-width: 1024px) {
  #headerControls {
    margin: 1rem;
  }
  #keymap {
    margin: 0 1rem 1rem;
  }
  #input {
    padding: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// app/translit/src/App.vue